import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDownObjective, DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNoteObjectiveMcKenzieSinglePanel extends React.Component {


    handleChange(event) {
        if ((event.target.value === '-1' || event.target.value === 'none') && this.props.comment !== null) {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEROM', 'RONO', this.props.rono, this.props.panel.MOPCOLUMNPREFIX + 'TXT');
        }
    }

    render() {

        let options = [
            { id: 'major', value: 'major' },
            { id: 'moderate', value: 'moderate' },
            { id: 'minimal', value: 'minimal' },
            { id: 'none', value: 'none' },
            { id: 'pain', value: 'pain' }
        ];

        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText={'McKenzie - Movement Loss - ' + this.props.panel.MOPLABEL} />
                <label title={this.props.panel.MOPHOVER} className={styles.mckenzie_label}>{this.props.panel.MOPLABEL}</label>
                <DBDropDownObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field={this.props.panel.MOPCOLUMNPREFIX}
                    className={styles.mckenzie_dropdown}
                    customOptions={options}
                    onChange={event => this.handleChange(event)}
                />
                {this.props.commentVisible &&
                    <span>
                        <span className={styles.mckenzie_comment_label} >Comments:</span>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEROM'
                            entityKeyColumn='RONO'
                            entityKeyValue={this.props.rono}
                            field={this.props.panel.MOPCOLUMNPREFIX + 'TXT'}
                            className={styles.mckenzie_comment}
                        />
                    </span>
                }
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];
    let flagged = false;
    let commentVisible = false;
    let comment = state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'TXT'];

    if (state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX] &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX] !== 'none') {
        flagged = true;
        commentVisible = true;
    }

    return {
        noteId: noteId,
        rono: rono,
        panel: panel,
        flagged: flagged,
        commentVisible: commentVisible,
        comment: comment
    };
}

const connectedPatientCareCenterNoteObjectiveMcKenzieSinglePanel = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveMcKenzieSinglePanel);
export { connectedPatientCareCenterNoteObjectiveMcKenzieSinglePanel as PatientCareCenterNoteObjectiveMcKenzieSinglePanel };


